/** Helper centralizzati per il push su window.dataLayer (GTM). */

type DataLayerPayload = Record<string, unknown>;

/** Push semplice, per eventi senza oggetto `ecommerce` (es. virtual_pageview, login). */
export function pushDataLayer(payload: DataLayerPayload) {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push(payload);
  }
}

/**
 * Push per eventi che trasportano un oggetto `ecommerce`.
 * Pusha sempre `{ ecommerce: null }` immediatamente prima del payload, così da
 * resettare l'ecommerce precedente (pattern GA4) legato al singolo evento.
 */
export function pushEcommerceEvent(payload: DataLayerPayload) {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
  }
}
